var map = {
	"./icons__headerquestion.png": 397,
	"./icons__row_1.png": 752,
	"./icons__row_2.png": 243,
	"./icons__row_3.png": 386,
	"./icons_cappuccino.png": 412,
	"./icons_cappuccino_user.png": 672,
	"./icons_creme.png": 463,
	"./icons_creme_user.png": 97,
	"./icons_espresso.png": 129,
	"./icons_espresso_user.png": 387,
	"./icons_filter.png": 795,
	"./icons_filter_user.png": 597,
	"./icons_flatwhite.png": 317,
	"./icons_flatwhite_user.png": 335,
	"./icons_latte.png": 219,
	"./icons_latte_user.png": 77,
	"./icons_nocoffee.png": 184,
	"./icons_ristretto.png": 501,
	"./icons_ristretto_user.png": 439,
	"./icons_schale.png": 119,
	"./icons_schale_user.png": 641
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 512;